import React from 'react';
import { languageOptions } from 'js/constants';
import DisplayActive from 'media/images/context-types/display-active.svg';
import DisplayInactive from 'media/images/context-types/display-inactive.svg';
import VideoActive from 'media/images/context-types/video-active.svg';
import VideoInactive from 'media/images/context-types/video-inactive.svg';
// import AppActive from 'media/images/context-types/app-active.svg';
// import AppInactive from 'media/images/context-types/app-inactive.svg';
import Box from 'js/components/box/box';
import Button from 'js/components/button/button';
import Input from 'js/components/input/input';
import JumboRadio from 'js/components/jumbo-radio/jumbo-radio';
import SectionTitle from 'js/components/section-title/section-title';
import Select from 'js/components/select/select';
import Text from 'js/components/text/text';
import contextTypes from 'js/enums/context-types.enum';
import steps from '../enums/steps.enum';
import styles from '../quick-start.module.scss';

const contextTypeOptions = [
    {
        label: 'Display',
        icons: [DisplayActive, DisplayInactive],
        value: contextTypes.DISPLAY,
        extra: 'Place ads on webpage content',
    },
    // {
    //     label: 'In App',
    //     icons: [AppActive, AppInactive],
    //     value: contextTypes.APP,
    //     extra: 'Place ads in mobile applications',
    // },
    {
        label: 'Video',
        icons: [VideoActive, VideoInactive],
        value: contextTypes.VIDEO,
        extra: 'Place ads on OLV and CTV content',
    },
];

const DetailsStep = ({ form, onFormChange, onStepChange }) => {
    const onChangeType = (type) => {
        // try to avoid having user insert DSP data again, unless integration doesn't support targeting type
        let updatedIntegration = form.integration;
        let updatedPartnerId = form.partner_id;

        if (
            type === contextTypes.APP &&
            ![null, true].includes(form.integration?.is_app)
        ) {
            updatedIntegration = null;
            updatedPartnerId = '';
        }

        if (
            type === contextTypes.VIDEO &&
            ![null, true].includes(form.integration?.is_video)
        ) {
            updatedIntegration = null;
            updatedPartnerId = '';
        }

        onFormChange({
            ...form,
            keywords: [],
            topics: [],
            integration: updatedIntegration,
            partner_id: updatedPartnerId,
            is_video: type === contextTypes.VIDEO,
            is_app: type === contextTypes.APP,
            type,
        });
    };

    return (
        <>
            <SectionTitle>
                Letʼs get started with some quick details about your context
            </SectionTitle>

            <Box margin={['large', 0, 0]}>
                <Box margin={['base', 0]}>
                    <Box margin={[0, 0, 'small']}>
                        <Text weight="bold" size="large">
                            Context Type
                        </Text>
                    </Box>
                    <JumboRadio
                        options={contextTypeOptions}
                        selectedValue={form.type}
                        onChange={(v) => onChangeType(v)}
                    />
                </Box>

                <Box margin={['base', 0]}>
                    <Input
                        label="Context Name"
                        maxLength={50}
                        value={form.context_name}
                        focusOnShow
                        onChange={(ev) =>
                            onFormChange({
                                ...form,
                                context_name: ev.target.value,
                            })
                        }
                    />
                </Box>

                <Box margin={['base', 0]}>
                    <Select
                        label="Language"
                        width="same"
                        options={languageOptions.filter((item) => item.value)}
                        selectedValues={form.language}
                        onChange={(language) =>
                            onFormChange({ ...form, language, keywords: [] })
                        }
                    />
                </Box>
            </Box>

            <Box margin={['large', 0, 0]}>
                <div className={styles['wizard-buttons']}>
                    <Button
                        disabled={!form.context_name.trim()}
                        onClick={() => onStepChange(steps.BUILD_CONTEXT)}
                    >
                        Continue
                    </Button>
                </div>
            </Box>
        </>
    );
};

export default DetailsStep;
